
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducer';
import Constants from './constants';
import { fitBounds } from 'google-map-react/utils';
import Geohash from 'latlon-geohash';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const centerInitialMap = (villas, clusters) => {

    const items = villas.concat(clusters)
    const allLats = items.map(item => (item.latitude))
    const allLngs = items.map(item => (item.longitude))
    const size = {
        width: 600, // Map width in pixels
        height: 300, // Map height in pixels
    };
    const bounds = {
        nw: {
            lat: Math.max.apply(null, allLats),
            lng: Math.min.apply(null, allLngs),
        },
        se: {
            lat: Math.min.apply(null, allLats),
            lng: Math.max.apply(null, allLngs),
        }
    };
    return fitBounds(bounds, size);
}
const getCookieZoomCenter = () => {
    
    if (center && zoom ) {
        return {center: center, zoom: zoom };
    } else {
        return {};
    }
}
export default function configureStore(initialState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    initialState.clusters = initialState.clusters.map((cluster) => {
        const hash = Geohash.decode(cluster.hash)
        return {
            latitude : hash.lat,
            longitude : hash.lon,
            quantity : cluster.quantity,
        }
    });
    const initial = centerInitialMap(initialState.villas, initialState.clusters );
    
    let defaultCenterZoom = {};
    const center = cookies.get('center');
    const zoom = parseInt(cookies.get('zoom'));
    if (center && zoom ) { 
        defaultCenterZoom = {center: center, zoom: zoom };
    }
    
    const store = createStore(
        reducer,
        {...initialState, ...initial, ...defaultCenterZoom },
        composeEnhancers(
            applyMiddleware(thunkMiddleware)
        )
    );
    return store;
};
